// InsigneCoins.js
import React, { useState } from "react";

const InsigneCoins = ({  onUseCoins }) => {

    return (
        <div className="insigne-coins-container">

                <button onClick={() => 
                    onUseCoins()
                }>
                    Usar InsigneCoins na compra
                </button>
        </div>
    );
};

export default InsigneCoins;
